<template>
  <Modal
    v-model="show"
    title="新增"
    :mask-closable="false"
    width="600"
    @on-ok="addQy"
    @on-cancel="modalCancel"
    :z-index="modelZIndex"
  >
    <div class="content-box">
      <!--单位名称-->
      <div class="box item-wrapper mar-btm">
        <div class="name">单位名称</div>
        <Input v-model="info.name" class="box_f1"  />
      </div>
      <!--工作时间-->
      <div class="box mar-btm">
        <div class="name">工作时间</div>
        <div>
          <div class="box mar-btm v_center">
            <div>日期</div>
            <Select v-model="info.startDay" class="input">
              <Option v-for="item in weekDay" :value="item.value" :key="item.value">{{ item.label}}</Option>
            </Select>
            <div>至</div>
            <Select v-model="info.endDay" class="input">
              <Option v-for="item in weekDay" :value="item.value" :key="item.value">{{ item.label}}</Option>
            </Select>
          </div>
          <div class="box v_center">
            <div>时间</div>
            <TimePicker type="time" format="HH:mm" :value="info.startTime" class="input" @on-change="changeStart"></TimePicker>
            <div>至</div>
            <TimePicker type="time" format="HH:mm" :value="info.endTime" class="input" @on-change="changeEnd"></TimePicker>
          </div>
        </div>
      </div>
      <!--工作电话-->
      <div class="box item-wrapper mar-btm">
        <div class="name">工作电话</div>
        <Input type="tel" v-model="info.phone" class="box_f1" />
      </div>
      <!--图片-->
      <div class="box mar-btm">
        <div class="name">图片</div>
        <div class="pic-box box">
          <div class="pic-wrapper" v-for="(item,index) in picList" @click="selectPic(index)">
            <img v-if="item.isSelect" src="../../../assets/images/select.png" class="select-pic">
            <img :src="item.url" class="pic" />
          </div>
        </div>

      </div>
    </div>
    <div slot="footer" class="box" style="justify-content: flex-end">
      <Button type="text" @click="modalCancel">取消</Button>
      <Button type="primary" @click="addPhoneInfo">确定</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    props:{
      showModel:{
        default:false,
        type:Boolean
      },
      phoneItem:null,
      picList:{
        default :[],
        type: Array,
      }
    },
    name: 'addPhone',
    data () {
      return {
        modelZIndex:200,
        show:false,
        info:{
          name:'',
          startDay:1,
          endDay:'周五',
          startTime:'8:00',
          endTime:'17:30',
          phone:'',
        },
        weekDay:[{
          label:'周一',
          value:1,
        },{
          label:'周二',
          value:2,
        },{
          label:'周三',
          value:3,
        },{
          label:'周四',
          value:4,
        },{
          label:'周五',
          value:5,
        },{
          label:'周六',
          value:6,
        },{
          label:'周日',
          value:0,
        }]
      }
    },
    watch:{
      showModel () {
        this.show = this.showModel
      },
      phoneItem () {
        if (!this._.isEmpty(this.phoneItem)) {
          this.info = JSON.parse(JSON.stringify(this.phoneItem))
        }else {
          this.info = {
              id:'',
              name:'',
              startDay:1,
              endDay:5,
              startTime:'8:00',
              endTime:'17:30',
              phone:''
          }
        }
      }
    },
    methods:{
      addQy () {

      },
      modalCancel () {
        this.$parent.closeModel()
      },
      selectPic (ind) {
        this.$parent.selectPic(ind)
      },
      changeStart (e) {
        this.info.startTime = e
      },
      changeEnd (e) {
        this.info.endTime = e
      },
      addPhoneInfo () {
        var url = this.urlobj.changePhone,
          item = this.info,
        headPicUrl = this.picList.filter(item => {
          return item.isSelect
        })
        if (!item.name) {
          this.$Message.warning('请填写单位名称')
          return
        }
        if (typeof (item.startDay) != 'number' || typeof (item.endDay) != 'number' || !item.startTime || !item.endTime) {
          this.$Message.warning('请填写工作时间')
          return
        }
        if (!item.phone) {
          this.$Message.warning('请填写工作电话')
          return
        }
        if (!headPicUrl.length) {
          this.$Message.warning('请选择图片')
          return
        }
        this.$post(url,{
          id:item.id,
          title:item.name,
          phoneNO:item.phone,
          beginWeek:item.startDay,
          beginTime:item.startTime+':00',
          endWeek:item.endDay,
          endTime:item.endTime+':00',
          headPicUrl:headPicUrl[0].url
        }).then(res => {
          if (res.isSucceed) {
            this.$Message.success('保存成功')
            this.$parent.saveSuccess()
          }else {
            this.$Message.error('保存失败，请重试')
          }
        })
      },
      checkMobile(str) {
        if (str.substring(0, 1) == 1) {
          var re = /^1\d{10}$/;
          if (re.test(str)) {
            return true
          } else {
            this.$Message.warning("电话格式不正确!");
            return false;
          }
        } else if (str.substring(0, 1) == 0) {
          var re = /^0\d{2,3}-?\d{7,8}$/;
          if (re.test(str)) {
            return true
          } else {
            this.$Message.warning("电话格式不正确!");
            return false;
          }
        } else {
          var re = /^(\d{7,8})(-(\d{3,}))?$/;
          if (re.test(str)) {
            return true
          } else {
            this.$Message.warning("电话格式不正确!");
            return false;
          }
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .mar-btm{
    margin-bottom: 20px;
  }
  .v_center{
    align-items: center;
  }
.content-box{
  font-size: 14px;
  padding-bottom: 30px;
  .item-wrapper{
    align-items: center;
  }
  .name{
    width: 60px ;
    margin-right: 20px;
    text-align: right;
  }
  .input{
    width: 160px;
    margin:0 10px
  }
  .pic-box{
    align-items: center;
    flex-wrap: wrap;
  }
  .pic-wrapper{
    height: 40px;
    width: 40px;
    position: relative;
    margin-right: 20px;
    margin-bottom: 20px;
    .select-pic{
      height: 15px;
      width: 15px;
      position: absolute;
      top:-7px;
      right: -7px;
    }
    .pic{
      height: 100%;
      width: 100%;
    }
  }
}
</style>
